export default {
  setTitulo(state, payload) {
    state.titulo = payload
  },
  setItens(state, payload) {
    state.itens = payload
  },
  setMotivos(state, payload) {
    state.motivos = payload
  },
  setProdutoSilenciadoEditar(state, payload) {
    state.item = payload
  },
  setProdutoSilenciadoQtde(state, payload) {
    state.produtoSilenciadoQtde = payload
  }
};
